import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material';
import { AuthService } from 'app/core/auth.service';
import { PostService } from 'app/core/post.service';
import { PostBuilderComponent } from 'app/forum/components/post-builder/post-builder.component';
import { ScheduledPostsDialogComponent } from 'app/forum/dialogs/scheduled-posts-dialog/scheduled-posts-dialog.component';
import { ForumPost } from 'app/forum/models/forum-post';
import { Group } from 'app/groups/models/group';
import { MondoUser } from 'app/shared/models/user/mondoUser';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreatePostComponent implements OnInit {
  @Input() group: Group;
  @Input() canCreatePosts: boolean;

  plannedPostsCountByGroup$: Observable<number>;

  constructor(
    public dialog: MatDialog,
    private postService: PostService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.plannedPostsCountByGroup$ = this.postService
      .getAllUserPlannedPosts()
      .pipe(
        map((posts) => posts.length),
        tap((count) => {
          this.setHeight(count);
        })
      );
  }

  setHeight(count = 0) {
    const doc = document.documentElement;
    if (count > 0) {
      doc.style.setProperty(`--planned-post-button`, `36px`, '');
      return;
    } else {
      doc.style.setProperty(`--planned-post-button`, `0px`, '');
    }
  }

  get user(): MondoUser {
    return this.authService.getCurrentUser();
  }

  isUserOfCompanyType(userType) {
    return AuthService.isUserOfCompanyType(userType);
  }

  async createPost() {
    const dialogRef = this.dialog.open(PostBuilderComponent, {
      width: 'calc(-24px + 100vw)',
      maxWidth: '840px',
      panelClass: 'create-post-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.post = this.postService.setNewPostProperties(
      new ForumPost(),
      this.group
    );
    dialogRef.componentInstance.updatingPost = false;
  }

  openScheduledPosts() {
    const dialogRef = this.dialog.open(ScheduledPostsDialogComponent, {
      width: '90vw',
      maxWidth: '550px',
      panelClass: 'schedule-post-dialog',
    });
  }
}
